import { render, staticRenderFns } from "./newSpu.vue?vue&type=template&id=7ee10970&scoped=true&"
import script from "./newSpu.vue?vue&type=script&lang=js&"
export * from "./newSpu.vue?vue&type=script&lang=js&"
import style0 from "./newSpu.vue?vue&type=style&index=0&id=7ee10970&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee10970",
  null
  
)

export default component.exports